import "./App.scss";
import React, { useEffect, useState } from "react";
import { Button, Form, Spinner, ThemeProvider } from "react-bootstrap";
import Router from "./routes";
import Card from "react-bootstrap/Card";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState("");

  async function handleLogin(event) {
    event.preventDefault();
    setLoginError("");
    setIsLoggingIn(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        },
      );

      if (!response.ok) {
        const message =
          response.status === 401
            ? "Invalid email or password."
            : "Unable to login. Try again.";
        throw new Error(message);
      }

      const data = await response.json();
      localStorage.setItem("GIA-UserName", data.name || data.email || email);
      setIsAuthenticated(true);
    } catch (error) {
      setLoginError(error.message || "Login failed.");
    } finally {
      setIsLoggingIn(false);
    }
  }

  useEffect(() => {
    const username = localStorage.getItem("GIA-UserName");
    // console.log("logged", username);
    if (username) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <ThemeProvider className="App">
      {!isAuthenticated && (
        <div className="login-content">
          <Card style={{ width: "18rem" }}>
            <Card.Header>Login</Card.Header>

            <Card.Body>
              <Form onSubmit={handleLogin} className="d-grid gap-3">
                <Form.Group className="text-start" controlId="loginEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="you@company.com"
                    required
                  />
                </Form.Group>
                <Form.Group className="text-start" controlId="loginPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    placeholder="********"
                    required
                  />
                </Form.Group>
                {loginError && (
                  <div className="text-danger text-sm">{loginError}</div>
                )}
                <Button type="submit" disabled={isLoggingIn}>
                  {isLoggingIn ? <Spinner size="sm" /> : "Login"}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      )}
      {isAuthenticated && <Router />}
    </ThemeProvider>
  );
}

export default App;
